interface IPriceFormatResult {
	composition: IPriceFormatResultComposition;
	result: string;
}
interface IPriceFormatResultComposition {
	symbolBefore: string;
	sign: string;
	thousands: string;
	thousandsSeparator: string;
	integers: string;
	decimals: string;
	decimalsSeparator: string;
	symbolAfter: string;
}

export interface ICurrencyBase {
	Symbol: string;
	DecDigits: number;
	HideDecimalsIfZero: boolean;
	SymbolBeforeValue: boolean;
	ThousandSep: string;
	DecimalSep: string;
}

export interface ICurrencyDefinitionModel extends ICurrencyBase {
	CurrencyID: string;
	Description: string;
	Conversion: number;
	RoundType: number;
	RoundUnit: number;
}

export interface ISystemCurrency {
	CurrencyID: string;
	Description: string;
	Symbol: string;
	DecDigits: number;
	ThousandSep: string;
	DecimalSep: string;
	SymbolBeforeValue: boolean;
	Conversion: number;
	RoundType: number;
	RoundUnit: number;
}

export function priceFormatted(amount: number, options: Partial<ICurrencyDefinitionModel>): IPriceFormatResult {
	const decimalSep = options.DecimalSep ?? ".";
	const decimalsDigitsOpt = options.DecDigits ? Math.abs(options.DecDigits) : 0;
	const decimalsDigits = isNaN(decimalsDigitsOpt) ? 0 : decimalsDigitsOpt;
	const thousandsSep = options.ThousandSep ?? "";
	const sign = amount < 0 ? "-" : "";
	const amountParsed = Math.abs(Number(amount) || 0).toFixed(decimalsDigits);
	const integerPart = parseInt(amountParsed);
	const integerPartString = integerPart.toString();
	const hasThousands = integerPartString.length > 3 ? integerPartString.length % 3 : 0;
	const hasDecimals = decimalsDigits > 0;
	const composition = {
		symbolBefore:
			options?.Symbol && options.SymbolBeforeValue ? options.Symbol : "",
		sign,
		thousands: hasThousands ? integerPartString.substr(0, hasThousands) : "",
		thousandsSeparator: hasThousands ? thousandsSep : "",
		integers: integerPartString
			.substr(hasThousands)
			.replace(/(\d{3})(?=\d)/g, "$1" + thousandsSep),
		decimals: hasDecimals
			? Math.abs(amount - integerPart)
				.toFixed(decimalsDigits)
				.split(".")[1]
			: "",
		decimalsSeparator: hasDecimals ? decimalSep : "",
		symbolAfter:
			options?.Symbol && !options.SymbolBeforeValue ? options.Symbol : ""
	};
	const result = (composition.symbolBefore ? composition.symbolBefore + " " : "")
		+ composition.sign
		+ (composition.thousands ? composition.thousands + composition.thousandsSeparator : "")
		+ composition.integers
		+ composition.decimalsSeparator
		+ composition.decimals
		+ (composition.symbolAfter ? " " + composition.symbolAfter : "");
	return { composition, result };
}

/** Convert a backend integer amount to a FE decimal amount. Apply at REST receive boundaries only. */
export function fromIntegerToDecimal(value: number): number {
	return value / 100;
}

/** Convert a FE decimal amount to a backend integer amount. Apply at REST send boundaries only. */
export function fromDecimalToInteger(value: number): number {
	return Math.round(value * 100);
}
